import { render, staticRenderFns } from "./edit_mode.vue?vue&type=template&id=2459d530"
import script from "./edit_mode.vue?vue&type=script&lang=js"
export * from "./edit_mode.vue?vue&type=script&lang=js"
import style0 from "./edit_mode.vue?vue&type=style&index=0&id=2459d530&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports